import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'super-layout',
  templateUrl: './super-layout.component.html',
  styleUrls: ['./super-layout.component.css']
})
export class SuperLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   
  }
 
}


